import LogoColored from "assets/images/logo/logo-colored.svg";
import { Fragment, memo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isAuthenticatedSelector, userSelector } from "store/auth";
import vars from "utils/vars";
import LocaleLink from "views/components/LocaleLink";

const HeaderLogo = ({ type, isDemo, className = "" }) => {
	const { t } = useTranslation();

	// redux global state
	const user = useSelector(userSelector);
	const isAuthenticated = useSelector(isAuthenticatedSelector);

	// constants
	const Wrapper = isDemo ? Fragment : LocaleLink;
	const wrapperOptions = {
		...(!isDemo
			? {
					to: `/${
						isAuthenticated && user?.subscription?.id && user?.signed && user?.status?.email_verified
							? "user/me"
							: ""
					}`,
			  }
			: {}),
	};

	return (
		<div className={`root-header-logo ${className}`}>
			<div className="d-flex h-100 py-2 px-0 align-items-center">
				<Wrapper {...(wrapperOptions || {})}>
					<img
						src={LogoColored}
						alt={`${vars.app.name} ${t("titles.home")}`}
						title={`${vars.app.name} ${t("titles.home")}`}
						width="200"
						height="60"
						className={`w-100 ${type === "home" ? "object-position-start object-fit-contain" : ""}`}
						data-testid="appLogo"
					/>
				</Wrapper>
			</div>
		</div>
	);
};

export default memo(HeaderLogo);
